import type { ConditionType } from '@validators/types'

export const inquiry: ConditionType = {
	name: {
		rules: ['require', 'isUserName', 'isLength[{"min": 0, "max": 30}]'],
		message: {
			require: 'Name is a required field.',
			isUserName: 'Only letters and spaces are allowed in the name field.',
			isLength: 'Please enter within 30 characters.',
		},
	},
	email: {
		rules: ['require', 'isEmail'],
		message: {
			require: 'Email is a required field.',
			isEmail: 'Please enter the email format in the email field.',
		},
	},
	categ: {
		rules: ['require'],
		message: {
			require: 'Password is a required field.',
		},
	},
	message: {
		rules: ['require'],
		message: {
			require: 'Confirm password is a required field.',
		},
	},
}

export default inquiry
